import {TWebsocketMessageHandlers} from 'websockets/core/websockets-types';

export interface IUseWebsocketNewsHandlersArgs {}

export const websocketNewsStaticHandlers: TWebsocketMessageHandlers = {
    newsAdded: () => {
        // console.log("Fires when news added.")
        // dispatch(setUnreadNews({...}))
    },
};
